export default __webpack_public_path__ + "static/media/MIXG.2ba4967d.jpg";